var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"caption",attrs:{"clipped-left":_vm.$vuetify.breakpoint.lgAndUp,"elevation-2":"","fixed":"","justify-center":"","app":"","color":"grey darken-3","dark":""}},[_vm._v(" "+_vm._s("COPYRIGHT ")+" © "+_vm._s(new Date().getFullYear() + " INTERNATIONAL CODE COUNCIL, INC. ALL RIGHTS RESERVED.")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }